import { fetchAllItems, fetchPage } from '@/utils/listResponse';

// Carga de catálogos para las pantallas de mantenimiento (specs/004-fix-listados-paginados).
//
// `loadCatalogItems(endpoint, page)` pide la página 1 (100 filas). Si el catálogo tiene
// COMPLETE_LIMIT filas o menos, trae el resto y devuelve TODAS las filas (modo completo: la
// pantalla sigue con su búsqueda y paginación locales). Si tiene más, activa `serverMode`: la
// pantalla pagina contra el servidor (`page`) y la búsqueda queda deshabilitada hasta que el
// backend ofrezca `search` para ese catálogo (FR-011).
//
// Devuelve el arreglo de filas, `[]` si hubo un error (y deja `error` con el mensaje) o `null`
// si otra carga más reciente reemplazó a ésta (la pantalla no debe aplicar el resultado).
// La pantalla debe definir `loadData(page)` que llame a `loadCatalogItems` para que
// `retryCatalog`, `serverPrev` y `serverNext` funcionen.
export const COMPLETE_LIMIT = 500;

export default {
  data() {
    return {
      loading: false,
      error: null,
      serverMode: false,
      serverPage: 1,
      serverTotalItems: 0,
      serverTotalPages: 1,
      catalogRequestId: 0,
      catalogAbort: null,
      lastCatalogPage: 1,
    };
  },

  computed: {
    searchDisabled() {
      return this.serverMode;
    },
    searchNotice() {
      return this.serverMode ? 'Búsqueda no disponible por ahora' : '';
    },
  },

  methods: {
    async loadCatalogItems(endpoint, page = 1) {
      const id = ++this.catalogRequestId;
      if (this.catalogAbort) this.catalogAbort.abort();
      const controller = new AbortController();
      this.catalogAbort = controller;
      const requested = this.serverMode ? page : 1;
      this.lastCatalogPage = requested;
      try {
        this.loading = true;
        this.error = null;
        const first = await fetchPage(endpoint, { page: requested, signal: controller.signal });
        if (id !== this.catalogRequestId) return null;

        if (first.totalItems > COMPLETE_LIMIT) {
          this.serverMode = true;
          this.serverPage = first.page;
          this.serverTotalItems = first.totalItems;
          this.serverTotalPages = Math.max(1, first.totalPages);
          return first.items;
        }

        this.serverMode = false;
        if (first.totalPages <= 1) return first.items;
        const all = await fetchAllItems(endpoint, {}, { first, signal: controller.signal });
        if (id !== this.catalogRequestId) return null;
        return all.items;
      } catch (err) {
        if (id !== this.catalogRequestId) return null;
        console.error('Error fetching data:', err);
        this.error = 'No se pudieron cargar los datos.';
        return [];
      } finally {
        if (id === this.catalogRequestId) this.loading = false;
      }
    },

    retryCatalog() {
      if (typeof this.loadData === 'function') return this.loadData(this.lastCatalogPage);
      return undefined;
    },

    serverPrev() {
      if (this.serverPage > 1 && typeof this.loadData === 'function') this.loadData(this.serverPage - 1);
    },

    serverNext() {
      if (this.serverPage < this.serverTotalPages && typeof this.loadData === 'function') this.loadData(this.serverPage + 1);
    },
  },
};
